import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import '../styles/UserProfile.css';
import { fetchUserProfile } from '../utils/api';
import { formatUtcToLocal } from '../utils/PageUtils';

const UserProfile = ({ userRole, bearerToken }) => {
    const [profileData, setProfileData] = useState(null);
    const [profileError, setProfileError] = useState(null);

    useEffect(() => {
        const fetchProfile = async () => {
            try {

                const response = await fetchUserProfile(bearerToken)
                if (response.success) {
                    setProfileData(response.data);
                }
                else {
                    setProfileError(response.message);
                }
            } catch {
                setProfileError('Unable to fetch profile data');
            }
        };
        fetchProfile();
    }, []);


    return (
        <div className="user-profile-container">
            {profileError && (
                <Alert variant="danger" style={{ width: '80%', margin: '4%' }}>
                    {profileError}
                </Alert>
            )}

            {profileData && (
                <div className="card-style">
                    <h1 className="profile-heading">User Profile</h1>
                    <div className="divider-style"></div>

                    <div className="profile-grid">
                        {/* Row 1 */}
                        <div className="grid-row">
                            <span className="label-style">Customer ID</span>
                            <span className="value-style">{profileData.customer_id}</span>
                        </div>
                        <div className="grid-row">
                            <span className="label-style">Name</span>
                            <span className="value-style">{profileData.user_name}</span>
                        </div>
                        {/* Row 2 */}
                        <div className="grid-row">
                            <span className="label-style">Email</span>
                            <span className="value-style">{profileData.email}</span>
                        </div>
                        {/* Row 3 */}
                        <div className="grid-row">
                            <span className="label-style">Mobile Number</span>
                            <span className="value-style">{profileData.phone}</span>
                        </div>
                        <div className="grid-row">
                            <span className="label-style">Organization</span>
                            <span className="value-style">{profileData.organization}</span>
                        </div>
                        <div className="grid-row">
                            <span className="label-style">Created Date</span>
                            <span className="value-style">{formatUtcToLocal(profileData.created)}</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserProfile;
